import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
import { Navigation } from 'swiper/modules';

$.widget('photoderm.cards', {
    options: {
        selectors: {
            cards: '[data-role=cards]',
            nextButton: '[data-role=next-button]',
            prevButton: '[data-role=prev-button]'
        }
    },

    _create() {
        this._bind();
    },

    _bind() {
        this._cache();
        this.initSliderCards();
        this.initVideo();
    },

    _cache() {
        this.$cards = $(this.options.selectors.cards);
        this.$cardsVideo = $('[data-role=cards-video]');
    },

    initSliderCards() {
        const { nextButton, prevButton } = this.options.selectors;

        const swiperNavigationOptions = {
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            }
        };

        new Swiper(this.$cards[0], {
            modules: [Navigation],
            slidesPerView: 'auto',
            spaceBetween: 12,
            watchOverflow: true,
            observer: true,
            observeParents: true,
            breakpoints: {
                768: {
                    spaceBetween: 23,
                    centeredSlides: true,
                    centeredSlidesBounds: true,
                    centerInsufficientSlides: true,
                },
            },
            ...swiperNavigationOptions,
        });
    },

    initVideo() {
        if (!this.$cardsVideo.length) {
            return;
        }

        const videoEl = this.$cardsVideo[0];

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    videoEl.load();
                    videoEl.play?.();
                    observer.disconnect();
                }
            });
        });

        observer.observe(videoEl);
    }
});

